import React, { useEffect, useState } from 'react';
import { ButtonBlockColumn } from './../../../common/sharedStyledComponents/GenericStyles.styled';
import { Modal } from '../../../../app/common/sharedComponents/Modal';
import { ButtonLarge } from '../../../../app/common/sharedComponents/buttons/ButtonLarge';
import { Body5, Headline3 } from '../../../../app/common/typography';
import {
  DeleteTitleContainer,
  DeleteMessageContainer,
} from './styled.questionCard';
import { useTranslation } from 'react-i18next';
import { IDeleteAttachmentModal } from '../../../../app/@types/questionCard';

export function DeleteAttachmentModal ({
  showDeleteModal,
  handleShowDeleteModal,
  handleAttachmentDelete,
  index,
  fileId,
  question,
  standardId,
  name,
  isLoadingImgDelete,
}: IDeleteAttachmentModal) {
  const { t } = useTranslation();

  const [isDeleteButtonClicked, setIsDeleteButtonClicked] = useState(false);

  useEffect(() => {
    if (isDeleteButtonClicked && !isLoadingImgDelete) {
      handleShowDeleteModal();
    }
  }, [isLoadingImgDelete, isDeleteButtonClicked]);

  const handleModalClose = () => {
    if (!isLoadingImgDelete) {
      handleShowDeleteModal();
    }
  };
  return (
    <Modal isOpen={showDeleteModal} handleModalClose={handleModalClose}>
      <ButtonBlockColumn>
        <DeleteTitleContainer>
          <Headline3>
            {t('COMMON.MY_AUDIT.CONDUCT.DELETE_ATTACHMENT.CONFIRMATION_TITLE')}
          </Headline3>
        </DeleteTitleContainer>
        <DeleteMessageContainer>
          <Body5>
            {t(
              'COMMON.MY_AUDIT.CONDUCT.DELETE_ATTACHMENT.CONFIRMATION_MESSAGE'
            )}
          </Body5>
        </DeleteMessageContainer>
        <ButtonLarge
          title={t('COMMON.BOTTOM_SHEET.DELETE')}
          backgroundColor="rustyRed"
          onClick={() => {
            if (handleAttachmentDelete) {
              handleAttachmentDelete(index, fileId, question, standardId, name);
            }
            setIsDeleteButtonClicked(true);
          }}
          loading={isLoadingImgDelete}
        />
        <ButtonLarge
          title={t('COMMON.BOTTOM_SHEET.CANCEL')}
          onClick={handleShowDeleteModal}
          outlined={true}
          inverted={true}
          disabled={isLoadingImgDelete}
        />
      </ButtonBlockColumn>
    </Modal>
  );
}
